import React from 'react';

interface SectionTitleProps {
  title: string;
}

const SectionTitle: React.FC<SectionTitleProps> = ({ title }) => {
  return (
    <div className='mt-[40px] mb-[25px]'>
      <div className=' '>
        <h1 className="box-border text-4xl font-semibold leading-tight mb-1.5 text-center text-[#005D6E]
         font-poppi">
          {title}
        </h1>
      </div>
    </div>
  );
};

export default SectionTitle;
 